import { render, staticRenderFns } from "./TidyCal.vue?vue&type=template&id=70aeacb8"
import script from "./TidyCal.vue?vue&type=script&lang=js"
export * from "./TidyCal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70aeacb8')) {
      api.createRecord('70aeacb8', component.options)
    } else {
      api.reload('70aeacb8', component.options)
    }
    module.hot.accept("./TidyCal.vue?vue&type=template&id=70aeacb8", function () {
      api.rerender('70aeacb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TidyCal.vue"
export default component.exports